import React, {Component} from 'react';
import axios from 'axios';
import { Tree } from 'primereact/tree';

class DocTree extends Component {
    state = {
        rawNamespaces : null,
        rawUdts : null,
        rawHierarchy : null
    }

    constructor(props) {
        super(props);
        this.udtDetailsComp = props.udtDetailsComp
        this.allUdtNames = props.allUdtNames

        console.log(this.udtDetailsComp)
    }

      
    _makeDocTreeLeaf(udtType, n) {
        var l = n.lastIndexOf(".")
        var label = n;
        if ( l > 0 )
            label = n.substr( l + 1);

        return { 
            key : n,
            label : label,
            icon : udtType + "AlfaNode",
            children : null
        }
    }

    _makeBranch( removePrefix, ns ) {
        let childNsNodes = this.state.rawHierarchy.NsHierarchy[ns]
        let childUdtNodes = this.state.rawHierarchy.NsUdts[ns]

        let childNss = []
        if ( childNsNodes )
            childNss = childNsNodes.map( cns => this._makeBranch(ns, cns) )

        let childUdts = []
        if ( childUdtNodes ) {
            childUdts = childUdtNodes.filter( e => ! e.Name.IsSynthetic ).map( u => this._makeDocTreeLeaf( u.Name.UdtType, u.Name.FullyQualifiedName) )
        }

        let all = childNss 
        if ( childUdts.length > 0 )
            all = all.concat(childUdts)   

        let lbl = ns
        // if ( removePrefix.length > 0)
        //     lbl = ns.substring(removePrefix.length + 1)

//        var l = ns.lastIndexOf(".")
//        if ( l > 0 )
//            lbl = ns.substr( l + 1);

        return { 
            key : ns,
            label : lbl,
            children : all
        }
    }

    _renderWithData() {

        let rootNamespaces = this.state.rawHierarchy.NsHierarchy[""]

        let data = rootNamespaces.map( ns => this._makeBranch("", ns) )

        return (
            <Tree value={data}
                selectionMode="single"
                selectionKeys={this.state.selectedNodeKey}
                onSelectionChange={e => this.udtDetailsComp.load(e.value)  }
                //onSelectionChange={e =>  console.log(e.value)  }
            />
        )
    }

    render() {
        if ( this.state.rawNamespaces && this.state.rawUdts && this.state.rawHierarchy ) {
            return this._renderWithData()
        }
        else {
            return (
                <div>
                    Loading Alfa Docs metadata...
                </div>
              );
        }
    }

    componentDidMount() {
        this.componentDidMountAxios()
//        this.componentDidMountUsingRequire()
    }

//    componentDidMountUsingRequire() {
//            this.setState({
//                rawNamespaces : require( "../schemas/AllNamespaces.json" ),
//                rawUdts : require( "../schemas/AllUdts.json" ),
//                rawHierarchy : require( "../schemas/AllHierarchy.json" )
//            })
//    }

    componentDidMountAxios() {
        axios.get('assets/schemas/AllNamespaces.json').then((response) => {
            this.setState({
                rawNamespaces : response.data,
                rawUdts : this.state.rawUdts,
                rawHierarchy : this.state.rawHierarchy
            })
            console.log(this.state);
        });

        axios.get('assets/schemas/AllUdts.json').then((response) => {
            this.setState({
                rawNamespaces : this.state.rawNamespaces,
                rawUdts : response.data,
                rawHierarchy : this.state.rawHierarchy
            })
            console.log(this.state);
        });

        axios.get('assets/schemas/AllHierarchy.json').then((response) => {
            this.setState({
                rawNamespaces : this.state.rawNamespaces,
                rawUdts : this.state.rawUdts,
                rawHierarchy : response.data
            })
            console.log(this.state);
        });
    }
}

export default DocTree;
